// adding some validations logic for cyber liability coverage (protection against hacking) insurance form
import { required, email, minLength, numeric, between } from 'vuelidate/lib/validators'

export const FORM_CYBER_VALIDATIONS = {
  userDataForm: {
    companyname: {
      required,
      minLength: minLength(2)
    },
    applicantname: {
      required,
      minLength: minLength(3)
    },
    email: {
      required,
      email
    },
    companytype: {
      required,
      minLength: minLength(5)
    },
    address: {
      required,
      minLength: minLength(15)
    },
    title: {
      required,
      minLength: minLength(5)
    },
    phonenumber: {
      required,
      numeric,
      minLength: minLength(10)
    },
    yearsestablished: {
      required,
      numeric
    },
    numberemployees: {
      required,
      between: between(100, 100000)
    },
    website: {
      required,
      minLength: minLength(8)
    }
  }
}



// WEBPACK FOOTER //
// ./src/validations/formCyber.js